/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../Fixes';
import Builder from '../../Builder';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "common": {
        "nested": {
          "number": {
            "nested": {
              "FixedPoint": {
                "fields": {
                  "value": {
                    "type": "sint64",
                    "id": 1,
                    "rule": "optional"
                  },
                  "scale": {
                    "type": "uint32",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.common?.nested?.number?.nested?.FixedPoint) {
  $root.addJSON(jsonData);
}

/**
 * Fixed point number.  Represented as value * 10 ^ -(scale).
 * Note that high scales may cause underflow.
 *
 * SOURCE FixedPoint @ squareup/common/number.proto at 12:1
 */
export const FixedPoint = $root.lookupType('squareup.common.number.FixedPoint');
fixType(FixedPoint, {
  value: {
    required: true
  },
  scale: {
    required: true
  }
});
Builder.createAndAttachToType(FixedPoint);